import { render, staticRenderFns } from "./sportbook-bets.vue?vue&type=template&id=a3c728cc&scoped=true&"
import script from "./sportbook-bets.vue?vue&type=script&lang=js&"
export * from "./sportbook-bets.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-bets.vue?vue&type=style&index=0&id=a3c728cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c728cc",
  null
  
)

export default component.exports